import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { PeriodicAudit } from 'data/periodicAudit/periodicAudit.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  periodicAFAuditData: PeriodicAudit,
  periodicAFAuditFormData: PeriodicAudit | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  const actionType = AuditActionType.PERIODIC_AUDIT_EDIT;
  const isEdit = true;

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(periodicAFAuditData, null, isEdit, periodicAFAuditFormData),
    periodicAFAuditData.id,
    AuditService.PERIODIC_AUDIT,
    actionType,
  );
  return auditDetails as AuditDetails;
}
